<template>

</template>

<script>
export default {
    name: "RedirectToStripe",
    props: {
        redirectUrl: {
            type: String,
            required: true,
        }
    },
    created() {
        if (this.redirectUrl) {
            window.location = this.redirectUrl
        }
    }
}
</script>

<style scoped>

</style>
